import { Controller, FieldPath, FieldValues, useFormContext } from 'react-hook-form';

import { CustomAutocompleteSelectField } from '@/components/shared/components/NewContextForms/shared/CustomAutocompleteSelectField';
import { CustomSelectFieldExtraProps } from '@/components/shared/components/NewContextForms/shared/CustomSelectField';
import { CustomTextFieldProps } from '@/components/shared/components/NewContextForms/shared/CustomTextField';
import { ReadOnlyDataRow } from '@/components/shared/components/NewContextForms/shared/ReadOnlyDataRow';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';

export interface SelectFormFieldProps<TFieldValues extends FieldValues>
  extends CustomTextFieldProps<TFieldValues>,
    CustomSelectFieldExtraProps {
  name: FieldPath<TFieldValues>;
  dummyField?: boolean;
}

export function AutocompleteSelectFormField<T extends FieldValues>({
  name,
  dummyField = false,
  ...props
}: SelectFormFieldProps<T>) {
  const formControl = useFormContext()?.control;

  if (!formControl || dummyField)
    return props.fieldVariant === FieldVariant.form ? (
      <CustomAutocompleteSelectField disabled={true} {...props} />
    ) : (
      <ReadOnlyDataRow {...props} />
    );

  return (
    <Controller
      name={name}
      control={formControl}
      render={({ field, fieldState: { error } }) => (
        <CustomAutocompleteSelectField fieldVariant={FieldVariant.form} {...props} field={field} error={error} />
      )}
    />
  );
}
